<template>
  <div>
    <modal-provider
      :fullscreenBreakpoint="850"
      :class="{'cart-modal--not-empty' : isCartNotEmpty}"
      name="cart-modal-new"
      :width="1345"
      @opened="modalOpened"
      v-on="!isCheckout && {'scroll' : showOrHideBtnBuy}"
      @scroll="showOrHideBtnBuy"
      ref="modal"
      classList="modal--cart cart"
      :title="$t('cart_title')"
    >
      <template v-slot:modal-heading>
        <h3 class="modal__title">
          {{ $t('cart_title') }}
        </h3>
      </template>
      <div v-if="cartSort.products.length">
        <div class="cart__wrapper">
          <ul class="cart__products-list">
            <li v-for="product in this.cartSort.products" :key="product.id" class="cart__products-list-item">
              <cart-item :product="product" :show-product-delivery-status="isCheckout" show-inner-items></cart-item>
            </li>
          </ul>
          <div
            class="modal__info modal__info--total"
            :class="{
              'modal__info--together-cheaper': discountSeveralGoodsParams,
              'modal__info--page--checkout': isCheckout
            }"
          >
            <div class="cart__buy-more" v-if="cartSort.cart">
              <p class="cart__buy-more-text" v-if="cartSort.cart.originCost < 750">
                {{ $t('cart_buy_more') }}
              </p>
              <button
                class="link link--pseudo cart__back-to "
                :class="{ 'cart__back-to--adaptive--show': isCheckout }"
                :title="$t('cart_return_to_shopping')"
                @click="hideModal"
              >
                <svg width="16"
                     height="16"
                     viewBox="0 0 16 16"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.8 7L9.4 1.4L8 0L0 8L8 16L9.4 14.6L3.8 9H16V7H3.8Z"
                    fill="#3E77AA"
                  />
                </svg>
                <span v-if="isCheckout">{{ $t('cart_return_to_checkout') }}</span>
                <span v-else>{{ $t('cart_return_to_shopping') }}</span>
              </button>
              <div class="cart__info-messages">
                <div
                  class="cart__info-message-wrap"
                  v-if="
                    (cartTotalPriceMoreThenTwoThousands &&
                      $t('cart_info_message_title_on') &&
                      $t('cart_info_message_text_on')) ||
                      (!cartTotalPriceMoreThenTwoThousands &&
                      $t('cart_info_message_title_off') &&
                      $t('cart_info_message_text_off'))
                  "
                >
                  <InfoMessageNew
                    :title="
                      cartTotalPriceMoreThenTwoThousands
                        ? $t('cart_info_message_title_on')
                        : $t('cart_info_message_title_off')
                    "
                    :text="
                      cartTotalPriceMoreThenTwoThousands
                        ? $t('cart_info_message_text_on')
                        : $t('cart_info_message_text_off')
                    "
                    :with-tooltip="
                      !!(cartTotalPriceMoreThenTwoThousands
                        ? $t('cart_info_message_text_on')
                        : $t('cart_info_message_text_off'))
                    "
                    custom-color="rgba(62, 119, 170, 0.1)"
                  />
                </div>
                <div class="cart__info-message-wrap" v-if="cart.notifications && cart.notifications.length">
                  <InfoMessageNew
                    v-for="(item, i) in cart.notifications"
                    :key="i"
                    :title="item.title"
                    :text="item.text"
                    :with-tooltip="!!item.text"
                    type="info"
                  />
                </div>
              </div>
            </div>
          </div>
          <ProductsBuyTogether
            v-if="cartProductsIds"
            :product-id-list="cartProductsIds"
            :title="$t('cart_buy_together_title')"
            :slider-breakpoints="buyTogetherSliderBreakpoints"
            :slider-space-between="15"
            simple-product-card
            without-container
            is-toggle-slider-show
            is-in-cart
          />
        </div>
        <div class="cart-modal__sticky-info" :class="{visible: !isBtnInViewport}" v-if="!isCheckout">
          <div class="cart-modal__sticky-info__price">
            {{ cartSort.cart.cartCost }}
          </div>
          <a
            @click="pushAnalyticEventNavToCheckout"
            :href="computedCheckoutData.link"
            class="cart__btn cart-modal__sticky-info__btn"
          >{{ computedCheckoutData.label }}
          </a>
        </div>
      </div>
      <div v-else-if="oneClickSuccess">
        <p class="modal__one-click-success" v-html="oneClickSuccess.message"></p>
        <span v-if="rtbHouseOneClickCode" v-html="rtbHouseOneClickCode"></span>
      </div>
      <div v-else class="empty-cart">
        <div class="empty-cart__img"></div>
        <h3 class="modal__title modal__title--center empty-cart__title">
          {{ $t('cart_empty_title') }}
        </h3>
        <p class="empty-cart__text">{{ $t('cart_empty_text') }}</p>
      </div>
      <aside v-if="isCartNotEmpty" class="modal-aside custom-scrollbar">
        <button @click="$modal.hide(cartModalName)" class="modal__close" :aria-label="$t('modal_close')"></button>
        <div class="modal-aside__box">
          <p class="modal-aside__title">{{ $t('cart.your_order') }}</p>
          <div class="cart__price" >
            <div
              v-if="cartSort.cart && fullOriginalCost && fullOriginalCost > cartSort.cart.originCost"
              class="cart__price-text"
            >
              <span class="cart__price-title">{{ $t('products') }}:</span>
              <div class="cart__price-number-wrap">
                <span class="cart__price-number" >{{ fullOriginalCost | currencyFormatter }}</span>
              </div>
            </div>
            <div v-if="hasDiscount" class="cart__price-text">
              <span class="cart__price-title">{{ $t('cart_discount') }}</span>
              <div class="cart__price-number-wrap">
                <span class="cart__price-number cart__price-number--discount">
                  – {{ discountValue | currencyFormatter }}
                </span>
              </div>
            </div>

            <div v-if="togetherCheaperDiscount" class="cart__price-text cart__price-text--together-cheaper">
              <span class="cart__price-title">{{ $t('cart_together_discount') }}</span>
              <div class="cart__price-number-wrap">
                <span class="cart__price-number cart__price-number--together-cheaper cart__price-number--discount">
                  -{{ togetherCheaperDiscount | currencyFormatter }}
                </span>
              </div>
            </div>
            <div v-if="cartSort.cart" class="cart__price-text cart__price-text--total">
              <span class="cart__price-title cart__price-title--total">{{ $t('cart.total_price') }}</span>
              <div class="cart__price-number-wrap">
                <span class="cart__price-number cart__price-number--total">{{ cartSort.cart.cartCost }}</span>
              </div>
            </div>
            <template v-if="!isCheckout">
              <hr class="cart__price-divider">
              <BonusesInModalNew :isCheckout="isCheckout" />
              <a
                ref="btnBuy"
                @click="pushAnalyticEventNavToCheckout"
                :href="computedCheckoutData.link"
                class="cart__btn cart__btn--buy"
              >{{ computedCheckoutData.label }}
              </a>
            </template>
          </div>

        </div>
        <div class="modal-aside__box" v-if="!discountSeveralGoodsParams && !isCheckout && !isManager">
          <span class="modal-aside__title modal-aside__title--sm">{{ $t('cart_one_click_title') }}</span>
          <p class="modal-asdie__paragraph" v-html="$t('cart_one_click_text')"></p>
          <QuickOrderForm
            class="one-click__form"
            is-buy-one-click
            :userData="userData"
            :productId="cartProductsIds[0]"
            is-from-cart
            @onSubmit="onQuickOrderFormSubmit"
            @onError="onQuickOrderFormError"
          >
            <template #form-footer="{ submitHandler, isButtonDisabled }">
              <button
                class="one-click-form__btn cart__btn cart__btn--invert"
                @click.prevent="submitQuickOrderForm(submitHandler)"
                :disabled="isOneClickLoading || isButtonDisabled"
              >
                {{ $t('quick_order') }}
              </button>
            </template>
          </QuickOrderForm>
        </div>
      </aside>
    </modal-provider>
    <notifications group="error" position="top center" :max="3"></notifications>
    <notifications group="success" position="top center" :max="3"></notifications>
    <notifications group="warn" position="top center" :max="3"></notifications>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import currencyFormatter from '../../filters/CurrencyFormatter'
import BonusesInModalNew from './BonusesInModalNew'
import InfoMessageNew from '../../components/helpers/InfoMessageNew'
import ProductsBuyTogether from '../../components/product/product-block/ProductsBuyTogether'
import { GoogleTagManagerService, EsputnikService } from '@/services/AnalyticService'
import QuickOrderForm from '@/components/product/quick-order/QuickOrderForm.vue'
import checkNodeVisibilityInViewPort from '@/helpers/checkNodeVisibilityInViewport'
import { debounce } from '@/mixins'
import CartItem from '@/components/cart/cart-item/CartItem'

export default {
  name: 'CartModalNew',
  components: {
    CartItem,
    ProductsBuyTogether,
    InfoMessageNew,
    BonusesInModalNew,
    QuickOrderForm
  },
  mixins: [debounce],
  props: {
    isCheckout: Boolean
  },
  data: function () {
    return {
      isOneClickLoading: false,
      discountSeveralGoodsParams: window.discountSeveralGoods,
      oneClickSuccess: false,
      rtbHouseOneClickCode: null,
      isBtnInViewport: false,
      buyTogetherSliderBreakpoints: {
        319: {
          slidesPerView: 1.5
        },
        375: {
          slidesPerView: 2.2
        },
        600: {
          slidesPerView: 3
        },
        850: {
          slidesPerView: 2.2
        },
        1024: {
          slidesPerView: 3.2
        },
        1300: {
          slidesPerView: 4
        }

      }
    }
  },
  methods: {
    ...mapActions(['FETCH_CART_BONUSES_INFO', 'SET_LOADING_COMPONENT']),
    showOrHideBtnBuy () {
      if (this.$refs.btnBuy) {
        this.debounce(() => {
          this.isBtnInViewport = checkNodeVisibilityInViewPort(this.$refs.btnBuy, true)
        }, 15)
      }
    },
    modalOpened () {
      // смотрим если ли во вьюпорте кнопка купить
      this.showOrHideBtnBuy()
    },
    hideModal () {
      this.$modal.hide(this.cartModalName)
    },
    onQuickOrderFormSubmit (data) {
      if (data.message) {
        this.oneClickSuccess = data
      } else if (!data.success) {
        this.$modal.hide(this.cartModalName)
        this.$modal.show('not-available-products', {
          ...data?.order['order_composition'],
          allProducts: this.cartSort.products
        })
      }
      if (data.success) {
        this.pushAnalyticsCode(data.orderNumber)

        // Отправка данных по заказу в eSputnik
        EsputnikService.sendPurchasedItemsInfo({
          products: data.analytics_data,
          orderNumber: data.orderNumber,
          tags: data.esputnikBlockId ? { 'blockId': [data.esputnikBlockId] } : null,
          isCheckout: false
        })
      }

      this.$store.dispatch('GET_FULL_CART').then(() => {
        this.isOneClickLoading = false
      })
    },
    onQuickOrderFormError (error) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: error,
        type: 'error'
      })
      this.isOneClickLoading = false
    },
    submitQuickOrderForm (handler) {
      this.isOneClickLoading = true
      handler()
    },
    pushAnalyticsCode (orderNumber) {
      if (this.isCartNotEmpty) {
        let transactionProducts = []
        for (let product of this.cartSort.products) {
          transactionProducts.push({
            name: `${product.name}`,
            sku: `${product.code}`,
            category: ``,
            price: `${product.price}`,
            quantity: `${product.itemQuantity}`
          })
        }

        GoogleTagManagerService.pushToDatalayer({
          transactionId: `${orderNumber}`, // Order number
          transactionAffiliation: `OneClick`,
          transactionTotal: `${this.cartSort.cart.originCost}`, // Total order sum
          transactionTax: ``,
          transactionShipping: ``,
          transactionProducts: transactionProducts
        })
      }
      GoogleTagManagerService.pushToDatalayer({
        event: `Purchase`,
        eventCategory: `ThankYou Page`,
        eventAction: `One-click-Purchase`,
        eventLabel: orderNumber
      })

      GoogleTagManagerService.checkoutEvent({
        analyticsData: this.cartInfoForEcommerce,
        actionField: { 'step': 6, 'option': 'One Click Cart Popup' },
        params: {
          'event': 'gtm-ee-event-checkout-step-6',
          'gtm-ee-event-action': 'Checkout Step 6 One Click Cart Popup'
        }
      })

      GoogleTagManagerService.purchaseEvent({
        analyticsData: this.cartInfoForEcommerce,
        actionField: {
          'id': orderNumber,
          'affiliation': 'One Click Cart Popup',
          'revenue': `${this.cart.originCost}`
        },
        params: {
          'event': 'gtm-ee-event-purchase',
          'gtm-ee-event-action': 'Purchase'
        }
      })

      const pushToFacebook = () => {
        try {
          window.fbq('track', 'Purchase', {
            content_ids: this.analyticsProductsCodes,
            content_type: 'product',
            value: `${this.cartSort.cart.originCost}`,
            currency: window.config?.currency?.currency_code
          })
        } catch (err) {
          setTimeout(function () {
            pushToFacebook()
          }, 1000)
        }
      }
      pushToFacebook()
    },
    pushAnalyticEventNavToCheckout () {
      GoogleTagManagerService.pushToDatalayer({
        'event': 'nav-to-cart-gtm-event',
        'eventCategory': 'nav_to_cart'
      })
    }
  },
  computed: {
    ...mapGetters([
      'urlLanguagePrefix',
      'cartSort',
      'cartInfoForEcommerce',
      'isCheckoutAsClient',
      'isManager',
      'cartTotalPriceMoreThenTwoThousands',
      'cartModalName'
    ]),
    ...mapState({
      isUserAuth: state => state.user.auth,
      cart: state => state.cart.cart,
      showCartRtbHouseCode: state => state.cart.showCartRtbHouseCode,
      cartProductsIds: state => state.cart.cartSort,
      userData: state => ({
        name: state.user.user_data?.name,
        lastName: state.user.user_data?.['last_name'],
        phone: state.user.user_data?.phone
      }),
      config: state => state.init.config
    }),
    computedCheckoutData () {
      let data = {
        link: this.urlLanguagePrefix + '/checkout/',
        label: this.$t('cart_buy_30_seconds')
      }

      if (this.isCheckoutAsClient && this.isManager) {
        data = {
          link: this.urlLanguagePrefix + '/manager-checkout/',
          label: this.$t('checkout_as_client')
        }
      }

      return data
    },
    analyticsProductsCodes () {
      if (this.isCartNotEmpty) {
        let codes = []
        for (let product of this.cartSort.products) {
          codes.push(product.code)
        }
        return codes.join()
      }
      return false
    },
    togetherCheaperDiscount () {
      let discount = null
      this.cartSort.products.forEach(function (product) {
        if (product.discount_amount) discount += product.discount_amount
        else {
          discount += product.itemQuantity * product.price - product.total_position_price
        }
      })
      return Math.floor(discount)
    },
    hasDiscount () {
      return (this.cart.discountInfo?.fullDiscountCost ?? 0) > 0
    },
    discountValue () {
      return this.cart.discountInfo?.fullDiscountCost ?? 0
    },
    fullOriginalCost () {
      return this.cart.discountInfo?.fullOriginalCost ?? 0
    },
    isCartNotEmpty () {
      return this.cartSort.products?.length > 0
    },
    isBonusServiceActive () {
      return this.config.service?.is_bonus_service_active
    }
  },
  filters: {
    currencyFormatter
  },
  watch: {
    cartSort () {
      if (this.isUserAuth && !this.isCheckout && this.cartModalName === 'cart-modal-new') {
        this.SET_LOADING_COMPONENT({ bonusesInModal: true })
        if (this.isBonusServiceActive) {
          this.FETCH_CART_BONUSES_INFO().then(() => this.SET_LOADING_COMPONENT({ bonusesInModal: false }))
        } else {
          this.SET_LOADING_COMPONENT({ bonusesInModal: false })
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">

$modal-aside-breakpoint: 850
::v-deep
  .modal-body
    padding-top: 0
    position: static

  .control-box.control-box--phone
    width: 286px
    margin-right: 0
  .control-box.control-box--code
    width: 100%
  .quick-order-form .form-group
    margin-bottom: 0
  +mmin($modal-aside-breakpoint)
    .modal
      overflow: hidden
      &-body
        overflow-y: auto
        overflow-x: hidden

.cart-modal--not-empty ::v-deep
  .modal-body
    +mmin(1100)
      height: 770px
      max-height: 100%
    +mmax($tablet--hor - 1)
      padding-bottom: 0
  .modal-heading .modal__close
    display: none
  .modal-body, .modal-heading
    +mmin($modal-aside-breakpoint)
      max-width: calc(100% - 410px)
    +mmin($large)
      max-width: calc(100% - 430px)

.modal-aside
  overflow-y: auto
  margin-left: -20px
  margin-right: -20px
  +mmin(450)
    margin-left: -30px
    margin-right: -30px
  +mmin($modal-aside-breakpoint)
    position: absolute
    right: 0
    top: 0
    height: 100%
    width: 410px
    border-left: 1px solid #E7E7E7
    margin-left: 0
    margin-right: 0

  &__title
    font-size: 24px
    color: $text-color
    margin: 5px 0
    font-weight: 500
    &--sm
      font-size: 18px
      line-height: 23px
      font-weight: 500
      color: $text-color
  &__box
    background-color: #fff
    padding: 30px 20px
    border-radius: 3px
    &:not(:last-child)
      border-bottom: 1px solid #E7E7E7
    +mmin(450)
      padding: 30px
    +mmin($modal-aside-breakpoint)
      padding: 30px 40px
  +mmin($large)
    width: 430px

.cart__products-list
  +list-unstyled

.cart__products-list-item
  padding: 20px 0 15px

  +mmin($tablet--hor)
    padding: 20px 0

  &:not(:first-child)
    border-top: 1px solid $nd-border-color

.cart__wrapper
  padding-bottom: 30px
  +mmax(768)
    padding-bottom: 15px

.cart__buy-more-text
  font-weight: 400 //Rubik 300
  font-size: 14px
  line-height: 17px
  color: $placeholder-color
  margin: 0 0 20px
  +mmax($extsmall--hor)
    margin-bottom: 30px

.cart__price
  margin-top: 30px

.cart__price-divider
  border-top: 1px solid #e7e7e7
  margin: 20px -5px
  +mmin($modal-aside-breakpoint)
    margin: 20px 0

.cart__price-text
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  & + &
    margin-top: 5px
  &--together-cheaper
    align-items: flex-end
    line-height: 19px
  &--total
    margin-top: 20px!important

.cart__price-title
  align-self: flex-end
  color: $text-color
  font-size: 16px
  line-height: 20px
  &--total
    font-size: 20px
    line-height: 25px
    font-weight: 500

.cart__price-number-wrap
  display: flex
  flex-direction: column
  align-items: flex-end
  min-width: 100px

.cart__price-number
  font-size: 16px
  line-height: 20px
  color: $text-color
  font-weight: 500
  &--total
    font-size: 20px
    line-height: 28px
    font-weight: 500
  &--discount
    text-align: right
    color: #FF2F00

.cart__back-to
  background-color: transparent
  font-weight: 400 //Rubik 300
  font-size: 15px
  line-height: 18px
  margin: auto 0 30px 30px
  position: relative
  +mmax($between-phone-tablet)
    display: none
  &--adaptive--show
    +mmax(768)
      display: inline-block
      margin-top: 20px
    +mmax($extsmall--hor)
      margin-top: 0

  svg
    position: absolute
    left: -30px
    vertical-align: middle
    margin-right: 10px

.cart__btn
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  height: 40px
  font-size: 15px
  font-weight: 500
  border: 1px solid $btn-bg
  border-radius: 3px
  background: $btn-bg
  color: $white-text-color
  transition: .4s
  cursor: pointer
  &:hover
    background-color: transparent
    color: $text-color
  &--buy
    margin: 30px 0 10px 0
  &--buy-manager
    background: #F0F0F0
    color: $text-color
    margin-top: 30px
    border-color: #F0F0F0
  &--invert
    border: 1px solid $btn-bg
    background: transparent
    color: $text-color
    &:hover
      background-color: $btn-bg
      color: $white-text-color

.modal__info
  &--total
    margin-top: 20px
    margin-bottom: 40px
  &--together-cheaper
    +mmax($between-phone-tablet)
      padding-bottom: 100px
  &--page--checkout
    +mmax(768)
      flex-direction: column-reverse

.one-click
  +mmax($between-phone-tablet)
    padding-bottom: 100px

.modal-asdie__paragraph
  font-size: 14px
  line-height: 1.5
  color: rgba(51, 51, 51, 0.7)
  margin: 15px 0 20px 0

.one-click__form
  max-width: 286px
  +mmax($extsmall--hor)
    max-width: none
  ::v-deep .quick-order-form__row
    flex-direction: column
    .quick-order-form__col
      width: 100%
    .quick-order-form__footer
      margin-top: 15px
    .control-box
      min-height: unset

.control-box--phone
  margin-bottom: 20px

.one-click-form__btn
  width: auto
  margin-top: 20px
  padding-left: 30px
  padding-right: 30px

.empty-cart
  +mmax($tablet)
    margin-top: 50px

.empty-cart__title
  margin-top: 40px
  font-size: 20px
  font-weight: 400
  +mmin($tablet)
    margin-top: 50px
    font-size: 24px

.empty-cart__text
  font-weight: 400 //Rubik 300
  font-size: 16px
  line-height: 19px
  text-align: center
  color: $placeholder-color
  margin-top: 10px

.empty-cart__img
  width: 120px
  height: 100px
  background-image: url(/img/svgo/empty-cart.svg)
  background-repeat: no-repeat
  background-size: contain
  margin: 0 auto

.sale-notification
  color: $nd-green-text-color
  font-size: 14px
  display: block
  margin-bottom: 20px
+mmin($tablet--hor + 1)
  .cart__info-messages
    display: flex

.cart__info-message-wrap
  margin: 0 0 15px
  +mmin($tablet--hor + 1)
    width: calc(50% - 7.5px)
    &:nth-child(odd)
      margin-right: 15px
  &:last-child
    margin: 0 0 40px
    +mmin($tablet)
      margin: 0

.cart-modal__sticky-info
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  background-color: #fff
  padding: 10px 20px
  display: flex
  z-index: 10
  align-items: center
  justify-content: space-between
  flex-wrap: nowrap
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.07)
  border-radius: 13px 13px 0 0
  transform: translate3d(0, 120%, 0)
  transition: .3s all ease
  &.visible
    transform: translate3d(0,0,0)
  +mmin($modal-aside-breakpoint)
    display: none !important
  &__price
    font-size: 20px
    color: $text-color
    font-weight: 500
  &__btn
    font-size: 14px
    font-weight: 500
    height: 40px
    width: auto
    padding: 0 20px
</style>
